import React from 'react';

import './collinsMpcPdfReport.css';

interface Props {
  repairRecommendationsList: any[];
}

const RepairRecommendations = ({ repairRecommendationsList }: Props) => {
  return (
    <div styleName="section-box no-margin">
      <div styleName="section-title">
        <div styleName="repair-title-column">Repair Recommendations</div>
        <div styleName="repair-quantity-column">Quantity</div>
        <div styleName="repair-units-column">Units</div>
        <div styleName="repair-priority-column">Repair Priority</div>
      </div>
      <div styleName="repair-content">
        {repairRecommendationsList.map(item => {
          return (
            <div styleName="repair-row" key={item.repairRecommendation}>
              <div styleName="repair-title-column">
                {item.repairRecommendation}
              </div>
              <div styleName="repair-quantity-column">{item.quantity}</div>
              <div styleName="repair-units-column">{item.unit}</div>
              <div styleName="repair-priority-column">
                {item.repairPriority}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RepairRecommendations;
